import {InProgressResponse} from '@stripe-internal/conversations-client';
import {captureException} from '@sentry/browser';
import {fetchEligibleChannels} from './channels';
import {
  RequestACallEndpointResponse,
  RequestACallCodesEndpointResponse,
  RequestACallVerificationCodeEndpointResponse,
} from '../../../../generated/types';

// TODO(MSE-4763): replace with the new RAC status endpoint
export async function inProgressRequestACall(
  supportFetch: typeof fetch,
  entryPoint: string,
  audience: string,
): Promise<InProgressResponse> {
  try {
    const {channels} = await fetchEligibleChannels(
      supportFetch,
      entryPoint,
      audience,
    );

    const inProgress = channels.some(
      (channel: {type: string; pending?: boolean}) =>
        channel.type === 'request_a_call' && channel.pending,
    );
    return {code: 200, data: {inProgress}};
  } catch (e) {
    const error = (e as Error).message;
    captureException(e);
    return {code: 400, error};
  }
}

export type RequestACallRequest = {
  phoneNumber: string;
  message: string;
  name: string;
  topic: string;
  entryPoint?: string;
  audience?: string;
  universalHelpConversationId?: string;
  analyticsEventId?: string | null;
};

export async function requestACall(
  supportFetch: typeof fetch,
  {
    phoneNumber,
    message,
    name,
    topic,
    entryPoint,
    audience,
    universalHelpConversationId,
    analyticsEventId,
  }: RequestACallRequest,
): Promise<RequestACallEndpointResponse> {
  return supportFetch('/api/request-a-call', {
    method: 'POST',
    body: JSON.stringify({
      phoneNumber,
      message,
      name,
      topic,
      entryPoint,
      audience,
      analyticsEventId,
      universalHelpConversationId,
    }),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((resp) => resp.json());
}

// TODO(MSE-4763): replace with the new RAC status endpoint
export async function fetchVerificationCodes(
  supportFetch: typeof fetch,
  audience: string,
): Promise<RequestACallVerificationCodeEndpointResponse> {
  return supportFetch(
    `/api/request-a-call/verification-code?redirectUrl=${document.referrer}&audience=${audience}`,
  ).then((resp) => resp.json());
}

export async function fetchRequestACallCodes(
  supportFetch: typeof fetch,
  entryPoint: string,
): Promise<RequestACallCodesEndpointResponse> {
  return supportFetch(`/api/request-a-call/codes?entry_point=${entryPoint}`, {
    method: 'POST',
  }).then((resp) => resp.json());
}

export async function inProgressRequestACallV2(
  supportFetch: typeof fetch,
  entryPoint: string,
): Promise<InProgressResponse> {
  const resp = await fetchRequestACallCodes(supportFetch, entryPoint);

  if (resp.type !== 'success') {
    return {code: 400, error: resp.error};
  }

  const {type: _, ...data} = resp;

  return {
    code: 200,
    data: {
      inProgress: data.pending,
      extra: data,
    },
  };
}
